import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* wifiActivationsResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Wifi/activateWfc", data);
    if (response?.statusCode == 1200) {
      yield put(actions.createWiFiActivationSuccess(response?.message));
    } else {
      yield put(actions.createWiFiActivationFailed(response?.message));
    }
  } catch (error) {
    yield put(actions.createWiFiActivationFailed(error));
  }
}

function* cancelWifiActivationsResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Wifi/CancelWfc", data);
    if (response?.statusCode == 1200) {
      yield put(actions.cancelWiFiActivationSuccess(response?.message));
    } else {
      yield put(actions.cancelWiFiActivationFailed(response?.message));
    }
  } catch (error) {
    yield put(actions.cancelWiFiActivationFailed(error));
  }
}


export default function* rootSaga() {
  yield all([
    takeEvery(actions.WIFI_ACTIVATION, wifiActivationsResponse),
    takeEvery(actions.CANCEL_WIFI_ACTIVATION, cancelWifiActivationsResponse)]);
}
